import { useMutation } from '@apollo/client/react';

import { GET_FILTERED_EVENTS, INSERT_EVENT_EXCEPTION } from '../../graphql/queries';
import useBuildGraphQLVariables from '../useBuildGraphQLVariables/useBuildGraphQLVariables';

function useCreateEventException() {
  const filters = useBuildGraphQLVariables(); // Build filters using the same method as your event fetching

  const [insertEventExceptionMutation, { loading, error }] = useMutation(INSERT_EVENT_EXCEPTION, {
    onError: (err) => {
      console.error('Error deleting event:', err);
    },
    refetchQueries: [
      {
        query: GET_FILTERED_EVENTS,
        variables: { filters: filters }, // Use the built filters for refetching
      },
    ],
  });

  const createEventException = (event_id: number, exceptionDate: Date, currentUser: string) =>
    insertEventExceptionMutation({
      variables: {
        event_exception: {
          event_id: event_id,
          exception_date: exceptionDate,
          exception_date_utc: exceptionDate,
          created_by: currentUser,
          updated_by: currentUser,
        },
      },
    });

  return { createEventException, loading, error };
}

export default useCreateEventException;
